import React,{useState} from 'react';
import "./Contact.css";
import EmailImg from "../assets/email.png";
import MobileImg from "../assets/mobile.png";
import {db} from "./firebase.js";
import { collection, addDoc } from "firebase/firestore"; 

function Contact() {
  const [name,setName] = useState();
  const [email,setEmail] = useState();
  const [message,setMessage] = useState();
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isLoading , setIsLoading] = useState(false);

  function handleSubmit(event){
    event.preventDefault();
    setIsLoading(true);
    setIsFormSubmitted(true);
    
    var today = new Date();
    try {
      const docRef = addDoc(collection(db, "users"), {
        Name: {name},
        Email: {email},
        Message: {message},
        time:{today}
      });
      console.log("Document written with ID: ", docRef.id);
    } catch (e) {
      console.error("Error adding document: ", e);
    }

    setIsLoading(false);
    setName("");
    setEmail("");
    setMessage("");

  }

  return (
    <div className='contact' id="contact">
      <h1 contact__headText>Take A Coffee & Chat With Me</h1>
      <div className='contact__cards'>
        <div className='contact__card'>
           <img src={EmailImg} alt="email" />
             <a href="mailto:robinrajaduraij@gmail.com" className='contact__mail'>robinrajaduraij@gmail.com</a>
        </div>
        <div className='contact__card'>
           <img src={MobileImg} alt="mobile" />
             <a href="tel: +91 9940997382" className='contact__mobile'>9940997382</a>
        </div>

      </div>
     
      <div className='contact__form'>
      <div className='contact__input'>
        <input type="text" value={name} name = "name" onChange={(e)=>setName(e.target.value)} placeholder="Your Name" />
      </div>
      <div className='contact__input'> 
        <input type="email" value={email} name = "email" onChange={(e)=>setEmail(e.target.value)} placeholder="Your Email" />
      </div>
       <div>
        <textarea className='contact__area' placeholder='Your Message' value={message} name="message" onChange={(e)=>setMessage(e.target.value)} />
       </div>
       <div className='contact__button'>
       <button onClick={handleSubmit}>{isLoading?"Sending":"Send Message"}</button>
       </div>
      </div>
      {isFormSubmitted?<div className='contact__submitted'><h3>Successfully Submitted</h3><p>Thank You for getting in touch</p></div>:""}
    </div>
  )
}

export default Contact;